import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Dropdown,
  Image,
} from "react-bootstrap";

import CommentInput from "./CommentInput";

const CommentBox = (props) => {
  const [comments, set_comments] = useState([]);
  const [comment, set_comment] = useState("");
  const [reply, set_reply] = useState("");
  const [comment_id_to_reply_to, set_comment_id_to_reply_to] = useState(null);
  const [contracted_comments, set_contracted_comments] = useState({});
  const [focused, set_focused] = useState(false);

  useEffect(() => {
    load();
  }, []);

  // Forced to rename from comment to addComment to avoid naming clashes with state variables
  const addComment = () => {
    return props.comment(comment).then(clearInput).then(load);
  };

  // Forced to rename from reply to addReply to avoid naming clashes with state variables
  const addReply = () => {
    return props
      .comment(reply, comment_id_to_reply_to)
      .then(clearInput)
      .then(load);
  };

  const approveOrDeny = (new_status_code, comment_uuid) => {
    return props.approveOrDeny(new_status_code, comment_uuid).then(load);
  };

  const clearInput = () => {
    set_comment("");
    set_reply("");
    set_comment_id_to_reply_to(null);
  };

  const load = () => {
    return props.getComments().then((comments) => {
      set_comments(comments);
      return comments;
    });
  };

  const onUpVote = (e) => {
    props.upVote(e.currentTarget.value);
  };

  const onDownVote = (e) => {
    props.downVote(e.currentTarget.value);
  };

  const onToggleContract = (e) => {
    const commentId = e.currentTarget.value;
    set_contracted_comments(
      Object.assign({}, contracted_comments, {
        [commentId]: !contracted_comments[commentId],
      })
    );
  };

  const onShowReply = (e) => {
    const reply = comment_id_to_reply_to !== e.currentTarget.value ? "" : reply;

    set_reply(reply);
    set_comment_id_to_reply_to(e.currentTarget.value);
  };

  const onHideReply = (e) => {
    set_reply("");
    set_comment_id_to_reply_to(null);
  };

  const onComment = (e) => {
    e.preventDefault();

    addComment();
  };

  const onReply = (e) => {
    e.preventDefault();

    addReply();
  };

  const onChangeComment = (e) => {
    set_comment(e.currentTarget.value);
  };

  const onChangeReply = (e) => {
    set_reply(e.currentTarget.value);
  };

  const handleKeyDown = (e) => {
    //console.log("handleKeyDown");
    e.target.style.height = "inherit";
    e.target.style.height = `${e.target.scrollHeight + 10}px`;
    // In case you have a limitation
    e.target.style.height = `${Math.min(e.target.scrollHeight, 200)}px`;
  };

  const handleFocus = () => {
    set_focused(true);
  };

  const renderCommentInput = (props) => {
    console.log("renderCommentInput", props);
    return (
      <Row className={`${prefix("comment-content")} mb-4`}>
        <Col xs={1} className="p-0">
          <Image
            roundedCircle
            fluid
            // className={prefix("user-avatar")}
            src={props.user_avatar_image_url}
            alt={""}
          />
        </Col>
        <Col xs={11}>
          <Form className={prefix("comment-form")} onSubmit={onComment}>
            <Form.Row>
              <Col xs={10}>
                <Form.Group controlId="exampleForm.ControlInput1">
                  <Form.Control
                    style={{
                      height: "41px",
                      overflow: "hidden",
                      resize: "none",
                    }}
                    maxLength={500}
                    as="textarea"
                    rows={1}
                    onChange={onChangeComment}
                    value={comment}
                    name="comment"
                    placeholder="Add a public comment (max. 500 characters)..."
                    onKeyDown={handleKeyDown}
                    onFocus={handleFocus}
                  />
                </Form.Group>
              </Col>
              <Col xs={2}>
                <Button
                  className="modal_button"
                  style={{ marginLeft: "20px", marginTop: "-5px" }}
                  type="submit"
                  disabled={!comment}
                >
                  Submit
                </Button>
              </Col>
            </Form.Row>
          </Form>
        </Col>
      </Row>
    );
  };

  const renderComment = (comment) => {
    return (
      <div style={{ marginBottom: "1rem" }}>
        <Row
          className={
            comment.status_code === 3
              ? prefix("comment-content-unapproved")
              : prefix("comment-content")
          }
        >
          <Col xs={1} className="p-0">
            {comment.user_profile_link ? (
              <Link target="_blank" to={comment.user_profile_link}>
                <Image
                  roundedCircle
                  fluid
                  src={comment.userAvatarUrl}
                  alt={comment.userNameDisplay}
                />
              </Link>
            ) : (
              <Image
                roundedCircle
                fluid
                src={comment.userAvatarUrl}
                alt={comment.userNameDisplay}
              />
            )}
          </Col>
          <Col xs={9}>
            <Row noGutters>
              {comment.user_profile_link ? (
                <Link
                  target="_blank"
                  to={comment.user_profile_link}
                  style={{ color: "black" }}
                >
                  <div
                    className={prefix("user-name")}
                    style={{ marginRight: "1rem", fontWeight: '600' }}
                  >
                    {comment.userNameDisplay || "Anonymous Coward"}
                  </div>
                </Link>
              ) : (
                <div
                  className={prefix("user-name")}
                  style={{ marginRight: "1rem", fontWeight: '600' }}
                >
                  {comment.userNameDisplay || "Anonymous Coward"}
                </div>
              )}
              <div
                className={prefix("timestamp")}
                style={{ fontWeight: "300" }}
              >
                {comment.timestampDisplay}
              </div>
            </Row>
            <Row noGutters>
              <div className={prefix("comment-body")}>
                {comment.bodyDisplay}
              </div>
            </Row>
          </Col>
          {comment.approvable && (
            <Col xs={2}>
              <Button
                className="modal_button"
                onClick={() => approveOrDeny(1, comment.id)}
              >
                Approve
              </Button>
              <Button
                className="modal_button"
                onClick={() => approveOrDeny(4, comment.id)}
              >
                Deny
              </Button>
            </Col>
          )}
          {comment.unapproved && (
            <Col xs={2}>
              <span style={{ fontStyle: "italic" }}>Waiting on approval</span>
            </Col>
          )}

          {(comment.editable || comment.deletable) && (
            <Col xs={2} className="flex justify-content-end">
              <Dropdown alignRight className="comment-dropdown">
                <Dropdown.Toggle>&#8942;</Dropdown.Toggle>
                <Dropdown.Menu>
                  {comment.editable && <Dropdown.Item>Edit</Dropdown.Item>}
                  {comment.deletable && (
                    <Dropdown.Item onClick={() => approveOrDeny(2, comment.id)}>
                      Delete
                    </Dropdown.Item>
                  )}
                </Dropdown.Menu>
              </Dropdown>
            </Col>
          )}
        </Row>
      </div>
    );
  };

  // removing 'get' but not sure a standard function will work the same as a class getter method.
  const renderedComments = () => {
    let temp_comments = [];
    const references = {};

    comments.forEach((comment) => {
      const {
        id,
        votes,
        bodyDisplay,
        userAvatarUrl,
        user_profile_link,
        userNameDisplay,
        timestampDisplay,
        belongsToAuthor,
        parentCommentId,
        className,
        status_code,
        approvable,
        unapproved,
        editable,
        deletable,
      } = props.normalizeComment(comment);

      references[id] = {
        id,
        votes,
        bodyDisplay,
        user_profile_link,
        userAvatarUrl,
        userNameDisplay,
        timestampDisplay,
        belongsToAuthor,
        replies: [],
        level: 0,
        className,
        status_code,
        approvable,
        unapproved,
        editable,
        deletable,
      };

      if (parentCommentId) {
        references[parentCommentId].replies.push(references[id]);
        references[id].level = references[parentCommentId].level + 1;
      } else {
        temp_comments.push(references[id]);
      }
    });
    return renderComments(temp_comments);
  };

  const renderComments = (comments) => {
    return comments.map((comment) => {
      return (
        <React.Fragment key={comment.id}>
          {renderComment(comment)}
        </React.Fragment>
      );
    });
  };

  const prefix = (className) => {
    return `${props.classPrefix}${className}`;
  };

  return (
    <Container className={props.className}>
      <Row style={{ paddingTop: "20px" }}>
        <span style={{ marginBottom: ".75rem" }} className={prefix("header")}>
          {comments.length} Comments
        </span>
      </Row>
      {!props.disabled ? (
        <React.Fragment>{renderCommentInput(props)}</React.Fragment>
      ) : (
        <CommentInput
          user_avatar_image_url={props.user_avatar_image_url}
          comment={comment}
          handleKeyDown={handleKeyDown}
          handleFocus={handleFocus}
          onChangeComment={onChangeComment}
          onComment={onComment}
          prefix={prefix}
        />
      )}
      {renderedComments()}
    </Container>
  );
};

export default CommentBox;
